import BusyLoader from "./BusyLoader";
import ToastManager from "./ToastManager";

export class NetworkManager {
  static serverPath: string = "http://52.42.49.205:8080/"; //https://api.joincaucus.com/ http://52.42.49.205:8080/
  static address: string = "";
  static jsonData: any = "";
  static qParam: string = "";
  static method: string = "";
  static successCallBack: any = "";
  static errorCallBack: any = "";

  static sendJsonRequest(
    address: string,
    jsonData: any,
    qParam: string,
    method: string,
    busy: boolean,
    successCallBack: any,
    errorCallBack: any
  ) {
    var serverUrl = this.serverPath + address;
    var requestOptions: object = {};
    if (qParam) {
      serverUrl = serverUrl + "?" + qParam;
    }
    if (busy) {
      BusyLoader.showLoader();
    }
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    if (
      address !== "cognito/login" &&
      address !== "cognito/mfa" &&
      address !== "broadcast/connect/fbUserAccount/save" &&
      address !== "broadcast/connect/fbUserAccount/getPages" &&
      address !== "broadcast/connect/fbUserAccount/page/connect" &&
      address !== "broadcast/connect/fbUserAccount/getAdAccounts"
    ) {
      if (localStorage.getItem("cognitoAccessToken")) {
        var token = "Bearer " + localStorage.getItem("cognitoAccessToken");
        myHeaders.append("Authorization", token);
      }
    }

    if (jsonData !== "") {
      var rawData = JSON.stringify(jsonData);
      requestOptions = { method: method, headers: myHeaders, body: rawData };
    } else {
      requestOptions = { method: method, headers: myHeaders };
    }

    fetch(serverUrl, requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (busy) {
          BusyLoader.hideLoader();
        }
        if (typeof result === "string") {
          successCallBack(result);
        } else if (typeof result === "object") {
          let response: any = result;
          if (response) {
            if (response.errorCode === "TOKEN_EXPIRED") {
              ToastManager.showToast(
                "Refresh Token Expired, Please Login again.",
                "Error"
              );
              // let refreshTokenAPI: string = "api/auth/refreshToken"; // + qParams;
              // let req: any = {};
              // req.refreshToken = localStorage.getItem("refreshToken");
            } else if (response.errorMessage === "EXPIRED_REFRESH_TOKEN") {
              // Confirm.show("Info", "Refresh Token Expired. Please login again.", [{label: 'OK', callback: function () {
              //        CommonUtil.onLogout();
              //   },
              // }])
            } else {
              successCallBack(JSON.stringify(result));
            }
          } else {
            successCallBack(JSON.stringify(result));
          }
        }
      })
      .catch((err) => {
        if (busy) {
          BusyLoader.hideLoader();
        }
        errorCallBack(err);
      });
  }
}
